__webpack_require__.p = "/github-finder/";